import AccessoriesHolder               from './accessories-holder/model-accessories-holder';
import AccessoriesHolders              from './accessories-holder/collection-accessories-holders';
import AlarmSwitch                     from './home-main-switches/main-alarm-switch/model-alarm-switch';
import AlarmSwitchs                    from './home-main-switches/main-alarm-switch/collection-alarm-switchs';
import BatteryAlert                    from './home-alerts/battery-alert/model-battery-alert';
import BatteryAlerts                   from './home-alerts/battery-alert/collection-battery-alerts';
import Calendar                        from './calendar/model-calendar'
import Calendars                       from './calendar/collection-calendars'
import ControlAccessoriesView          from './accessories-holder/view-control-accessories-view';
import ControlAlarmView                from './view-control-alarm-view';
import ControlApplicationInstallView   from './view-control-application-install-view';
import ControlContainer                from './view-control-container';
import ControlCalendarEntriesView      from './calendar/view-control-calendar-entries-view';
import ControlDayAndNight              from './day-and-night/view-control-day-and-night-view';
import ControlDigiHeat                 from './digiheat/view-digiheat-view';
import ControlDetailsView              from './view-control-details-view';
import ControlFinderView               from './map/view-control-finder-view'
import ControlGpaiView                 from './general-alarm-switches/view-control-gpai';
import ControlGeneralHomeView          from './warmup-settings/view-control-general-home-view';
import ControlGenericStatesView        from './generic-state/view-control-generic-states-view';
import ControlHomeAlertView            from './home-alerts/view-control-home-alerts-view';
import ControlMapView                  from './view-control-map-view';
import ControlNoteView                 from './note/view-control-note-view';
import ControlNotificationsView        from './notification-holders/view-control-notifications-view';
import ControlSettingsView             from './view-control-settings-view';
import ControlSwitchesView             from './home-main-switches/view-control-switches-view';
import ControlTechnicalView            from './view-control-technical-view';
import ControlWarmupStatesView         from './warmup-state/view-control-warmup-states-view';
import ControlWeatherView              from './view-control-weather-view';
import ControlZonesView                from './view-control-zones-view';
import DayAndNightSetting              from './day-and-night/model-day-and-night-setting';
import DayAndNightSettings             from './day-and-night/collection-day-and-night-settings';
import DigiHeat                        from './digiheat/model-digiheat';
import DigiHeats                       from './digiheat/collection-digiheats';
import Finder                          from './map/model-finder';
import Finders                         from './map/collection-finders';
import FollowMainAlarm                 from './general-alarm-switches/follow-main-alarm/model-follow-main-alarm';
import FollowMainAlarms                from './general-alarm-switches/follow-main-alarm/collection-follow-main-alarms';
import GeneralAlarmInput               from './general-alarm-switches/general-alarm-input/model-general-alarm-input';
import GeneralAlarmInputs              from './general-alarm-switches/general-alarm-input/collection-general-alarm-inputs';
import GenericState                    from './generic-state/model-generic-state';
import GenericStates                   from './generic-state/collection-generic-states';
import HeatingSwitch                   from './home-main-switches/heating-switch/model-heating-switch';
import HeatingSwitchs                  from './home-main-switches/heating-switch/collection-heating-switchs';
import Module                          from 'scripts/module';
import NotificationHolder              from './notification-holders/model-notification-holder';
import NotificationHolders             from './notification-holders/collection-notification-holders';
import PickupTime                      from './pickup-times/model-pickuptime';
import PickupTimes                     from './pickup-times/collection-pickuptimes';
import PowerAlert                      from './home-alerts/power-alert/model-power-alert';
import PowerAlerts                     from './home-alerts/power-alert/collection-power-alerts';
import TemperatureAlert                from './home-alerts/temperature-alert/model-temperature-alert';
import TemperatureAlerts               from './home-alerts/temperature-alert/collection-temperature-alerts';
import WarmupSetting                   from './warmup-settings/model-warmup-setting';
import WarmupSettings                  from './warmup-settings/collection-warmup-settings';
import WarmupState                     from './warmup-state/model-warmupstate';
import WarmupStates                    from './warmup-state/collection-warmupstates';
import Security                        from './security/model-security';
import Securitys                       from './security/collection-securitys';
import ZoneHolder                      from './zone-holder/model-zone-holder';
import ZoneHolders                     from './zone-holder/collection-zone-holders';

const ControlsModule = new Module( 'ControlsModule', {
	views: {
		ControlAccessoriesView,
		ControlAlarmView,
		ControlApplicationInstallView,
		ControlCalendarEntriesView,
		ControlContainer,
		ControlDayAndNight,
		ControlDigiHeat,
		ControlFinderView,
		ControlGpaiView,
		ControlGeneralHomeView,
		ControlGenericStatesView,
		ControlHomeAlertView,
		ControlMapView,
		ControlNoteView,
		ControlNotificationsView,
		ControlDetailsView,
		ControlTechnicalView,
		ControlSettingsView,
		ControlSwitchesView,
		ControlWarmupStatesView,
		ControlWeatherView,
		ControlZonesView
	},
	collections: {
		AccessoriesHolders,
		AlarmSwitchs,
		Calendars,
		DigiHeats,
		BatteryAlerts,
		DayAndNightSettings,
		Finders,
		FollowMainAlarms,
		GeneralAlarmInputs,
		GenericStates,
		HeatingSwitchs,
		NotificationHolders,
		PickupTimes,
		PowerAlerts,
		TemperatureAlerts,
		WarmupSettings,
		WarmupStates,
		ZoneHolders,
	},
	models: {
		AccessoriesHolder,
		AlarmSwitch,
		Calendar,
		DigiHeat,
		BatteryAlert,
		DayAndNightSetting,
		Finder,
		FollowMainAlarm,
		GeneralAlarmInput,
		GenericState,
		HeatingSwitch,
		NotificationHolder,
		PickupTime,
		PowerAlert,
		Security,
		TemperatureAlert,
		WarmupSetting,
		WarmupState,
		ZoneHolder,
	}
} );
export default ControlsModule;
